import { render, staticRenderFns } from "./Chevron.vue?vue&type=template&id=b99a096c&scoped=true"
import script from "./Chevron.vue?vue&type=script&lang=js"
export * from "./Chevron.vue?vue&type=script&lang=js"
import style0 from "./Chevron.vue?vue&type=style&index=0&id=b99a096c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99a096c",
  null
  
)

export default component.exports